import React, { useEffect, useRef } from "react";
import "../../components/styles/magazine.css";
import "../../App.css";

import { LineSection } from "../../components/graphics/line-drawing";
import { InViewContainer } from "../../components/hooks/in-View";
import {
  Audience,
  Brain,
  Gobo,
  LightBulb,
} from "../../components/graphics/sketches";
import { RiveLetter, RiveLogo } from "../../components/graphics/rive-component";
import { ImageBackground } from "../../components/UI/image-background";
export const HomePage = () => {
  const ref = useRef();

  useEffect(() => {
    const paths = document.querySelectorAll(".path");
    paths.forEach((element) => {
      const length = element.getTotalLength();
      element.setAttribute("stroke-dashoffset", length);
      element.setAttribute("stroke-dasharray", length);
    });
  }, []);

  return (
    <>
      <section className="landing-page" ref={ref}>
        <LineSection id={0} />
        <RiveLogo classes="logo" triggerOnce={false} />
        <div className="built-different">
          <img
            width="445"
            src="/assets/images/Built.png"
            alt="built differently"
          />
        </div>
      </section>
      <section>
        <LineSection id={1} />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h1>
            WE’RE{" "}
            <span className="highlight">THE HUMAN EXPERIENCE AGENCY.</span>
          </h1>
          <p>
            As a fresh live experience agency, we work across the corporate,
            leadership and brand space delivering everything from major events
            and launches to activations and integrated campaigns.
          </p>
          <a className="button cta" href="mailto:info@the-agency.live">
            Drop us a line
          </a>
        </InViewContainer>
      </section>
      <section>
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h1>HX: Human Experience™</h1>
          <p>
            Using our HX methodology, we listen deeply for the human shift that
            matters most, then build experiences full of empathy, heart and
            originality.
            <br />
            <br /> It’s clear. It’s felt. It sticks.
          </p>
        </InViewContainer>
        <InViewContainer
          as={"div"}
          classes="brain"
          triggerOnce={true}
          threshold={0.2}
        >
          <Brain />
        </InViewContainer>
      </section>
      <section id="about">
        <LineSection id={2} />
        <ImageBackground
          classes="mask-both"
          image="/assets/images/paint-explos.jpg"
        />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h1>
            <span className="highlight">EXPERT HANDS, </span>ON HAND.
          </h1>
          <p>
            Senior, hands-on and embedded. The people you meet are the people
            who deliver, start to finish. We slot into your team like we’ve
            always been there; packed with experience, creativity and
            unstoppable energy.
            <br />
            <br />
            No layers. No hand-offs.
          </p>
        </InViewContainer>
      </section>
      <section id="what" className="half">
        <LineSection id={3} />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h2>What we do</h2>
        </InViewContainer>
      </section>
      <section className="magazine-section">
        <InViewContainer as={"div"} triggerOnce={true} threshold={0.2}>
          <div className="magazine left">
            <Audience />

            <div className="magazine-body">
              <h3>Live Experiences</h3>
              <p>
                We design and deliver live, virtual and hybrid experiences
                people feel part of. From brand activations to leadership
                moments, everything is joined-up, purposeful and built to land.
              </p>
            </div>
          </div>
        </InViewContainer>
        <InViewContainer as={"div"} triggerOnce={true} threshold={0.2}>
          <div className="magazine right">
            <div className="magazine-body">
              <h3>Content and Storytelling</h3>
              <p>
                We shape the thinking behind the moment. From narrative and
                messaging to content creation and speaker coaching, we turn
                ideas into something clear, confident and memorable.
              </p>
            </div>
            <LightBulb />
          </div>
        </InViewContainer>
        <InViewContainer as={"div"} triggerOnce={true} threshold={0.2}>
          <div className="magazine left">
            <Gobo />

            <div className="magazine-body">
              <h3>Creative production</h3>
              <p>
                Through production mastery and smart use of technology, we bring
                environments to life with precision and impact; physical,
                digital or hybrid. Every element elevates the experience and
                lifts the message.
              </p>
            </div>
          </div>
        </InViewContainer>
      </section>
      <section className="half">
        <LineSection id={4} />
        <InViewContainer
          as={"div"}
          classes={"title-box how-title"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h2 id="how">The Human Experience effect</h2>
        </InViewContainer>
      </section>
      <section>
        <LineSection id={5} />
        <ImageBackground
          classes="mask-both"
          image="assets/images/hand-heart.jpg"
        />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h1>
            MOST EVENTS INFORM. WE
            <span className="highlight"> BUILD BELIEF.</span>
          </h1>
          <p>
            <strong>For brands.</strong> We create launches and experiences that
            people talk about.
            <br />
            <br />
            <strong>For teams.</strong> We turn strategy into shared belief and
            align people behind change.
            <br />
            <br />
            <strong>For leaders.</strong> We handle high-stakes moments with
            clarity, connection and trust.
          </p>
        </InViewContainer>
      </section>
      <section>
        <LineSection id={6} />
        <ImageBackground classes="mask-both" image="assets/images/eye.jpg" />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h1>
            LIVE EXPERIENCES <span className="highlight">OUTPERFORM.</span>
          </h1>
          <p>
            Because they give people what they value most:
            <br />
            <em>connection, belonging and a part to play.</em>
          </p>
        </InViewContainer>
      </section>
      <section>
        <LineSection id={2} />
        <ImageBackground classes="mask-both" image="assets/images/drop.jpg" />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h5>
            The organisations getting it right are building{" "}
            <em className="highlight">experiences,</em> not just audiences. And
            the people they inspire don’t just believe -{" "}
            <em className="highlight">they bring others with them.</em>
          </h5>
        </InViewContainer>
      </section>
      <section className="contact-us" id="contact">
        <ImageBackground
          classes="mask-top"
          image="assets/images/heart-card.jpg"
        />
        <InViewContainer
          as={"div"}
          classes={"title-box"}
          threshold={0.2}
          triggerOnce={true}
        >
          <h5>
            Engineered for outcomes.
            <br />
            <br />
            Designed for humans, by expert hands.
          </h5>
          <div className="end-logo">
            <RiveLogo classes={"logo"} triggerOnce={false} />

            <div className="built-different">
              <img
                width="445"
                src="/assets/images/Built.png"
                alt="built differently"
              />
            </div>
          </div>
          <a className="button cta center" href="mailto:info@the-agency.live">
            Drop us a line
          </a>
        </InViewContainer>
        <InViewContainer as={"div"} threshold={0.2} triggerOnce={true}>
          <RiveLetter />
        </InViewContainer>
      </section>
    </>
  );
};
